import type { OtherUser } from '@talos/kyoko';
import { useUsersContext } from '../providers/UsersContext';

export const useUsers = (): OtherUser[] => {
  const { users } = useUsersContext();
  return users;
};
